import React from 'react';

export const CompassIcon = (props) => (
    <svg width="7" height="36" viewBox="0 0 7 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M5.40674 5H4.74707L2.2417 1.16504V5H1.58203V0.0234375H2.2417L4.75391 3.87549V0.0234375H5.40674V5Z" fill="#1B3134" />
        <path d="M3.5 13L6.53109 23.5H0.468911L3.5 13Z" fill="#1B3134" />
        <path d="M5.86634 26L3.5 34.1972L1.13367 26L5.86634 26Z" stroke="#1B3134" />
    </svg>
);